const getEnv = function () {
  const { hostname } = window.location;

  if (hostname === 'candidate.ignite.sunrun.com') {
    console.log('E PR CONNECT');
    return 'prod';
  }

  if (hostname === 'candidate.stage.ignite.sunrun.com') {
    console.log('E SG CONNECT');
    return 'stage';
  }

  if (hostname === 'candidate.ignite.sunrundev.com') {
    console.log('E DV CONNECT');
    return 'dev';
  }
  console.log('E LC CONNECT');
  return 'local';
};

export default {
  getEnv,
};
